import type { ChangeEvent, FC } from 'react';
import React from 'react';

import { Radio } from '@motorway/mw-highway-code/alpha';

import type { Filter } from 'Types/filter';

import type { RadioFilterConfig } from './AllFiltersContent.consts';

import styles from './AllFiltersContent.module.scss';

interface RadioSectionProps {
	config: RadioFilterConfig;
	filters: Filter;
	onChange: (from: Nullable<number>, to: Nullable<number>) => void;
}

const getSelectedValue = (config: RadioFilterConfig, filters: Filter): string => {
	const from = filters[config.fromId as keyof Filter] ?? null;
	const to = filters[config.toId as keyof Filter] ?? null;

	const match = config.options.find((option) => option.from === from && option.to === to);
	return match?.value ?? config.options[0].value;
};

export const RadioSection: FC<RadioSectionProps> = ({ config, filters, onChange }) => {
	const selectedValue = getSelectedValue(config, filters);

	const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
		const option = config.options.find((opt) => opt.value === target.value);
		if (option) {
			onChange(option.from, option.to);
		}
	};

	return (
		<div className={styles.radioSection}>
			{config.options.map((option) => (
				<Radio
					key={option.value}
					formProps={{
						input: {
							checked: selectedValue === option.value,
							name: `${config.fromId}-radio`,
							onChange: handleChange,
							value: option.value,
						},
					}}
					id={`${option.value}-${config.fromId}`}
					label={option.label}
				/>
			))}
		</div>
	);
};
